<template>
    <section class="cta-section">
		    <div class="container">
			    <div class="row align-items-center">
				     <div class="col-lg-7">
					      <div class="cta-content">
						      <h3>Earn Cash by <span>Selling</span> <br>
							  or Find Anything you desire							     
							  </h3>
							  <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humo or randomised words which don't look even slightlys</p>
							  <div class="cta-btn">
							     <router-link to="add-listing" class="btn-primary postad-btn">Post Your Ads</router-link>
							     <router-link to="listing-grid-sidebar" class="browse-btn">Browse Ads</router-link>							  
							  </div>
						  </div>
					 </div>
				     <div class="col-lg-5">
					       <div class="cta-img">
						        <img src="@/assets/img/cta-img.png" class="img-fluid" alt="CTA">
						   </div>
					 </div>
				</div>
			</div>
		</section>
</template>